import { GridColumnType } from "../../../../../../data/gridColumnType";

export const employeeTimesheetGridConfig = {
    columns: [
        {
            name: "Week Start Date",
            fieldName: "startDate",
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY'
            }
        },
        {
            name: "Week End Date",
            fieldName: "endDate",
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY'
            }
        },
        {
            name: "Status Type",
            fieldName: "statusType",
        },
        {
            name: "Submit Date",
            fieldName: "lastSubmittedDate",
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY'
            }
        },
        {
            name: "Approved Date",
            fieldName: "approvedAt",
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY'
            }
        },
        {
            name: "Approved By",
            fieldName: "approvedBy",
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: false,
            },
        },
    ],
}